// extracted by mini-css-extract-plugin
export default {"main":"main_main__PxH2L"};